var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "email",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.325,
    height: 13.5,
    viewBox: "0 0 18.325 13.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_76001",
    "data-name": "Group 76001",
    transform: "translate(0 3.81)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76000",
    "data-name": "Group 76000",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139575",
    "data-name": "Path 139575",
    d: "M9.692,152.456a1.042,1.042,0,0,1-1.082,0L0,147.2v6.986a2.705,2.705,0,0,0,2.7,2.7H15.62a2.705,2.705,0,0,0,2.7-2.7V147.2Z",
    transform: "translate(0 -147.2)",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_76003",
    "data-name": "Group 76003",
    transform: "translate(0.087 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76002",
    "data-name": "Group 76002",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_139576",
    "data-name": "Path 139576",
    d: "M17.582,57.088H4.666A2.689,2.689,0,0,0,2.048,59.21l9.087,5.542L20.2,59.21A2.689,2.689,0,0,0,17.582,57.088Z",
    transform: "translate(-2.048 -57.088)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7ae114a5cec3511640f29b272355084c.svg";
export { ForwardRef as ReactComponent };